import React, { useState, useEffect } from 'react';
import { supabase } from '../services/supabase';
import { useAuth } from '../context/AuthContext';

const TABS = ['Mesajlar', 'FAQ', 'SEO', 'Sosial', 'Elan'];

const SUBJECT_LABELS = {
  general: 'Ümumi',
  business: 'Biznes',
  support: 'Dəstək',
  press: 'Mətbuat',
  corporate: 'Korporativ',
};

// ── Contact Messages ──────────────────────────────────────────────────────────
function ContactMessages() {
  const { getAdminToken } = useAuth();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => { load(); }, []);

  // contact_messages RLS ilə bağlandı (PII) — oxuma yalnız admin RPC ilə
  const load = async () => {
    setLoading(true);
    const { data } = await supabase.rpc('admin_get_contact_messages', {
      p_admin_token: getAdminToken(),
    });
    setMessages(data || []);
    setLoading(false);
  };

  const markRead = async (id) => {
    await supabase.rpc('admin_mark_contact_read', {
      p_admin_token: getAdminToken(), p_id: id,
    });
    setMessages(prev => prev.map(m => m.id === id ? { ...m, is_read: true } : m));
  };

  const unread = messages.filter(m => !m.is_read).length;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '340px 1fr', gap: 20, height: 600 }}>
      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #E2E8F0', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '14px 16px', borderBottom: '1px solid #F1F5F9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: 700, fontSize: 14 }}>Mesajlar</span>
          {unread > 0 && <span style={{ background: '#E63950', color: '#fff', fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 10 }}>{unread} yeni</span>}
        </div>
        <div style={{ overflow: 'auto', flex: 1 }}>
          {loading ? (
            <div style={{ padding: 20, textAlign: 'center', color: '#94A3B8' }}>Yüklənir...</div>
          ) : messages.length === 0 ? (
            <div style={{ padding: 32, textAlign: 'center', color: '#94A3B8' }}>Mesaj yoxdur</div>
          ) : messages.map(msg => (
            <div
              key={msg.id}
              onClick={() => { setSelected(msg); if (!msg.is_read) markRead(msg.id); }}
              style={{
                padding: '12px 16px', cursor: 'pointer', borderBottom: '1px solid #F8FAFC',
                background: selected?.id === msg.id ? '#FFF1F3' : msg.is_read ? '#fff' : '#FFFBFC',
                borderLeft: `3px solid ${selected?.id === msg.id ? '#E63950' : msg.is_read ? 'transparent' : '#E63950'}`,
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 3 }}>
                <span style={{ fontWeight: msg.is_read ? 600 : 800, fontSize: 14, color: '#1E293B' }}>{msg.name}</span>
                <span style={{ fontSize: 11, color: '#94A3B8' }}>{new Date(msg.created_at).toLocaleDateString('az-AZ')}</span>
              </div>
              <div style={{ fontSize: 12, color: '#64748B', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{msg.message}</div>
              <span style={{ fontSize: 11, background: '#F1F5F9', color: '#64748B', padding: '2px 6px', borderRadius: 6, marginTop: 4, display: 'inline-block' }}>
                {SUBJECT_LABELS[msg.subject] || msg.subject}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #E2E8F0', padding: 24 }}>
        {selected ? (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
              <div>
                <h3 style={{ fontSize: 18, fontWeight: 800, color: '#1E293B' }}>{selected.name}</h3>
                <div style={{ fontSize: 13, color: '#64748B', marginTop: 3 }}>
                  <a href={`mailto:${selected.email}`} style={{ color: '#E63950' }}>{selected.email}</a>
                  {' · '}
                  <span>{new Date(selected.created_at).toLocaleString('az-AZ')}</span>
                </div>
              </div>
              <span style={{ background: '#FFF1F3', color: '#E63950', fontSize: 12, fontWeight: 700, padding: '4px 12px', borderRadius: 10, alignSelf: 'flex-start' }}>
                {SUBJECT_LABELS[selected.subject]}
              </span>
            </div>
            <div style={{ background: '#F8FAFC', borderRadius: 12, padding: 20, fontSize: 14, lineHeight: 1.75, color: '#374151', marginBottom: 20 }}>
              {selected.message}
            </div>
            <a
              href={`mailto:${selected.email}?subject=Re: Cafegoo Müraciəti`}
              style={{
                display: 'inline-block', padding: '10px 20px', borderRadius: 10,
                background: 'linear-gradient(135deg, #E63950, #FF6B6B)',
                color: '#fff', fontSize: 14, fontWeight: 700,
              }}
            >
              Cavabla →
            </a>
          </>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#94A3B8', flexDirection: 'column', gap: 12 }}>
            <span style={{ fontSize: 40 }}>💬</span>
            <span>Mesaj seçin</span>
          </div>
        )}
      </div>
    </div>
  );
}

// ── FAQ Manager ───────────────────────────────────────────────────────────────
const LANG_TABS = [
  { code: 'az', label: '🇦🇿 AZ', qKey: 'question',    aKey: 'answer'    },
  { code: 'en', label: '🇬🇧 EN', qKey: 'question_en', aKey: 'answer_en' },
  { code: 'tr', label: '🇹🇷 TR', qKey: 'question_tr', aKey: 'answer_tr' },
  { code: 'ru', label: '🇷🇺 RU', qKey: 'question_ru', aKey: 'answer_ru' },
];

const EMPTY_FORM = {
  question: '', answer: '',
  question_en: '', answer_en: '',
  question_tr: '', answer_tr: '',
  question_ru: '', answer_ru: '',
  order_num: 0,
};

function FAQManager() {
  const [faqs, setFaqs]         = useState([]);
  const [loading, setLoading]   = useState(true);
  const [form, setForm]         = useState(EMPTY_FORM);
  const [editing, setEditing]   = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [activeLang, setActiveLang] = useState('az');

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    const { data } = await supabase.from('website_faqs').select('*').order('order_num');
    setFaqs(data || []);
    setLoading(false);
  };

  const save = async () => {
    if (!form.question || !form.answer) return;
    if (editing) {
      await supabase.from('website_faqs').update(form).eq('id', editing);
    } else {
      await supabase.from('website_faqs').insert({ ...form, order_num: faqs.length });
    }
    setForm(EMPTY_FORM);
    setEditing(null); setShowForm(false);
    load();
  };

  const del = async (id) => {
    if (!window.confirm('Silinsin?')) return;
    await supabase.from('website_faqs').delete().eq('id', id);
    load();
  };

  const startEdit = (faq) => {
    setForm({
      question:    faq.question    || '',
      answer:      faq.answer      || '',
      question_en: faq.question_en || '',
      answer_en:   faq.answer_en   || '',
      question_tr: faq.question_tr || '',
      answer_tr:   faq.answer_tr   || '',
      question_ru: faq.question_ru || '',
      answer_ru:   faq.answer_ru   || '',
      order_num:   faq.order_num   || 0,
    });
    setEditing(faq.id);
    setShowForm(true);
  };

  const currentTab = LANG_TABS.find(l => l.code === activeLang);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <button onClick={() => { setShowForm(!showForm); setEditing(null); setForm({ ...EMPTY_FORM, order_num: faqs.length }); }}
          style={{ padding: '9px 18px', borderRadius: 10, background: '#E63950', color: '#fff', fontSize: 14, fontWeight: 700 }}>
          + Yeni FAQ
        </button>
      </div>

      {showForm && (
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #E2E8F0', padding: 20, marginBottom: 20 }}>
          <div style={{ display: 'flex', gap: 4, marginBottom: 16, background: '#F8FAFC', borderRadius: 8, padding: 4, width: 'fit-content' }}>
            {LANG_TABS.map(l => (
              <button key={l.code} onClick={() => setActiveLang(l.code)} style={{
                padding: '6px 14px', borderRadius: 6, fontSize: 12, fontWeight: 700, border: 'none', cursor: 'pointer',
                background: activeLang === l.code ? '#fff' : 'transparent',
                color: activeLang === l.code ? '#1E293B' : '#94A3B8',
                boxShadow: activeLang === l.code ? '0 1px 4px rgba(0,0,0,0.1)' : 'none',
              }}>
                {l.label}
              </button>
            ))}
          </div>

          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 5 }}>
              Sual ({currentTab.label})
              {currentTab.code !== 'az' && <span style={{ color: '#94A3B8', fontWeight: 400, marginLeft: 6 }}>— boş qalsa AZ versiyası göstərilər</span>}
            </label>
            <input value={form[currentTab.qKey]} onChange={e => setForm({ ...form, [currentTab.qKey]: e.target.value })}
              style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid #E2E8F0', fontSize: 14, boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 5 }}>
              Cavab ({currentTab.label})
            </label>
            <textarea rows={3} value={form[currentTab.aKey]} onChange={e => setForm({ ...form, [currentTab.aKey]: e.target.value })}
              style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid #E2E8F0', fontSize: 14, resize: 'vertical', boxSizing: 'border-box' }} />
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <button onClick={save} style={{ padding: '9px 18px', borderRadius: 8, background: '#10B981', color: '#fff', fontSize: 13, fontWeight: 700 }}>Saxla</button>
            <button onClick={() => setShowForm(false)} style={{ padding: '9px 18px', borderRadius: 8, background: '#F1F5F9', color: '#64748B', fontSize: 13 }}>Ləğv et</button>
          </div>
        </div>
      )}

      {loading ? <div style={{ textAlign: 'center', padding: 32, color: '#94A3B8' }}>Yüklənir...</div> :
        faqs.map((faq, i) => (
          <div key={faq.id} style={{ background: '#fff', borderRadius: 12, border: '1px solid #E2E8F0', padding: '14px 18px', marginBottom: 10, display: 'flex', gap: 14, alignItems: 'flex-start' }}>
            <div style={{ width: 28, height: 28, borderRadius: 8, background: '#FFF1F3', color: '#E63950', fontWeight: 800, fontSize: 13, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{i + 1}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: '#1E293B', marginBottom: 4 }}>{faq.question}</div>
              <div style={{ fontSize: 13, color: '#64748B', lineHeight: 1.6, marginBottom: 6 }}>{faq.answer}</div>
              <div style={{ display: 'flex', gap: 6 }}>
                {LANG_TABS.slice(1).map(l => (
                  <span key={l.code} style={{
                    fontSize: 10, fontWeight: 700, padding: '2px 7px', borderRadius: 6,
                    background: faq[l.qKey] ? '#ECFDF5' : '#F8FAFC',
                    color: faq[l.qKey] ? '#10B981' : '#CBD5E1',
                  }}>
                    {l.label} {faq[l.qKey] ? '✓' : '—'}
                  </span>
                ))}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
              <button onClick={() => startEdit(faq)}
                style={{ padding: '5px 12px', borderRadius: 7, background: '#F1F5F9', fontSize: 12, fontWeight: 600, color: '#475569' }}>Düzəlt</button>
              <button onClick={() => del(faq.id)}
                style={{ padding: '5px 12px', borderRadius: 7, background: '#FFF1F3', fontSize: 12, fontWeight: 600, color: '#E63950' }}>Sil</button>
            </div>
          </div>
        ))
      }
    </div>
  );
}

// ── Logo Upload ───────────────────────────────────────────────────────────────
function SiteLogo() {
  const [logoUrl,   setLogoUrl]   = useState(null);
  const [uploading, setUploading] = useState(false);
  const [msg,       setMsg]       = useState('');

  useEffect(() => {
    supabase.from('site_settings').select('value').eq('key', 'logo_url').maybeSingle()
      .then(({ data }) => { if (data) setLogoUrl(data.value); });
  }, []);

  const showMsg = (t) => { setMsg(t); setTimeout(() => setMsg(''), 3000); };

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const ext = file.name.split('.').pop();
      const { error: upErr } = await supabase.storage
        .from('business-photos')
        .upload(`site/logo.${ext}`, file, { upsert: true, contentType: file.type });
      if (upErr) throw upErr;
      const { data: urlData } = supabase.storage.from('business-photos').getPublicUrl(`site/logo.${ext}`);
      const url = urlData.publicUrl;
      await supabase.from('site_settings').upsert({ key: 'logo_url', value: url }, { onConflict: 'key' });
      setLogoUrl(url);
      showMsg('✅ Logo yükləndi');
    } catch (err) {
      showMsg('❌ ' + err.message);
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = async () => {
    await supabase.from('site_settings').delete().eq('key', 'logo_url');
    setLogoUrl(null);
    showMsg('🗑 Logo silindi');
  };

  return (
    <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #E2E8F0', padding: 24, marginBottom: 24, maxWidth: 480 }}>
      <div style={{ fontWeight: 800, fontSize: 15, color: '#1E293B', marginBottom: 4 }}>🖼 Sayt Logosu</div>
      <div style={{ fontSize: 13, color: '#64748B', marginBottom: 16 }}>
        Navbar-da görünən Cafegoo logosu. Yüklənməsə standart ikon istifadə olunur.
      </div>

      {msg && (
        <div style={{ fontSize: 13, fontWeight: 600, padding: '8px 12px', borderRadius: 8, marginBottom: 12,
          background: msg.startsWith('✅') ? '#ECFDF5' : '#FEF2F2',
          color:      msg.startsWith('✅') ? '#10B981' : msg.startsWith('🗑') ? '#64748B' : '#E63950',
        }}>{msg}</div>
      )}

      <div style={{
        width: 200, height: 64, borderRadius: 12, border: '1.5px dashed #E2E8F0',
        background: '#F8FAFC', display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: 16, overflow: 'hidden',
      }}>
        {logoUrl
          ? <img src={logoUrl} alt="logo" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
          : <span style={{ fontSize: 12, color: '#CBD5E1' }}>Logo yoxdur</span>
        }
      </div>

      <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
        <label style={{
          padding: '9px 18px', borderRadius: 9, background: uploading ? '#F1F5F9' : '#E63950',
          color: uploading ? '#94A3B8' : '#fff', fontSize: 13, fontWeight: 700,
          cursor: uploading ? 'not-allowed' : 'pointer',
        }}>
          {uploading ? 'Yüklənir...' : '📤 Logo Yüklə'}
          <input type="file" accept="image/*" style={{ display: 'none' }} disabled={uploading} onChange={handleUpload} />
        </label>
        {logoUrl && (
          <button onClick={handleRemove} style={{
            padding: '9px 14px', borderRadius: 9, border: '1px solid #FECACA',
            background: '#FFF1F3', color: '#E63950', fontSize: 13, fontWeight: 700, cursor: 'pointer',
          }}>Sil</button>
        )}
      </div>
    </div>
  );
}

// ── SEO Manager ───────────────────────────────────────────────────────────────
const SEO_FIELDS = [
  { key: 'seo_title',       label: 'Səhifə Başlığı (Title)',   hint: 'Max 60 simvol. Google axtarışında görünür.',        type: 'input',    maxLen: 60  },
  { key: 'seo_description', label: 'Meta Açıqlama',            hint: 'Max 160 simvol. Axtarış nəticəsinin altında.',       type: 'textarea', maxLen: 160 },
  { key: 'seo_keywords',    label: 'Açar Sözlər (Keywords)',   hint: 'Vergüllə ayrılmış sözlər: kafe, restoran, Bakı',     type: 'input',    maxLen: 255 },
  { key: 'seo_canonical',   label: 'Canonical URL',            hint: 'Nümunə: https://cafegoo.com (dublikat URL problemini aradan qaldırır)', type: 'input', maxLen: 255 },
  { key: 'twitter_card',    label: 'Twitter/X Card Tipi',      hint: 'X-də paylaşılanda görünəcək kart növü',             type: 'select',   options: ['summary', 'summary_large_image'] },
  { key: 'twitter_site',    label: 'Twitter/X Handle',         hint: 'Nümunə: @cafegooapp',                               type: 'input',    maxLen: 50  },
  { key: 'google_analytics',label: 'Google Analytics ID',      hint: 'Nümunə: G-XXXXXXXXXX',                              type: 'input',    maxLen: 30  },
  { key: 'ga4_measurement', label: 'GA4 Measurement ID',       hint: 'Nümunə: GT-XXXXXXXX',                               type: 'input',    maxLen: 30  },
  { key: 'gsc_verify',      label: 'Google Search Console',    hint: 'Meta tag content dəyəri (verification code)',       type: 'input',    maxLen: 100 },
  { key: 'og_image_url',    label: 'OG Image URL',             hint: 'Sosial şəbəkələrdə paylaşılanda görünən şəkil URL',  type: 'input',    maxLen: 500 },
];

function SEOManager() {
  const [settings, setSettings] = useState({});
  const [saving,   setSaving]   = useState(false);
  const [msg,      setMsg]      = useState('');
  const [socials,  setSocials]  = useState({});

  useEffect(() => { load(); }, []);

  const load = async () => {
    const seoKeys = SEO_FIELDS.map(f => f.key);
    const socialKeys = ['social_instagram','social_facebook','social_x','social_linkedin','social_youtube','social_tiktok','logo_url'];
    const allKeys = [...seoKeys, ...socialKeys];
    const { data } = await supabase.from('site_settings').select('key, value').in('key', allKeys);
    if (data) {
      const map = {};
      data.forEach(row => { map[row.key] = row.value; });
      const seoMap = {};
      seoKeys.forEach(k => { if (map[k] !== undefined) seoMap[k] = map[k]; });
      setSettings(seoMap);
      setSocials(map);
    }
  };

  const handleChange = (key, val) => setSettings(prev => ({ ...prev, [key]: val }));

  const saveAll = async () => {
    setSaving(true);
    const rows = SEO_FIELDS
      .filter(f => settings[f.key] !== undefined)
      .map(f => ({ key: f.key, value: settings[f.key] || '' }));
    const { error } = await supabase.from('site_settings').upsert(rows, { onConflict: 'key' });
    setSaving(false);
    setMsg(error ? '❌ ' + error.message : '✅ SEO ayarları saxlandı');
    setTimeout(() => setMsg(''), 3000);
  };

  const charCount = (key, max) => {
    const len = (settings[key] || '').length;
    const color = len > max ? '#E63950' : len > max * 0.85 ? '#F59E0B' : '#10B981';
    return <span style={{ fontSize: 11, color, fontWeight: 600 }}>{len}/{max}</span>;
  };

  // Build JSON-LD preview
  const buildJsonLd = () => {
    const sameAs = [
      socials['social_instagram'], socials['social_facebook'],
      socials['social_x'], socials['social_linkedin'],
      socials['social_youtube'], socials['social_tiktok'],
    ].filter(Boolean);
    const obj = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Cafegoo',
      url: settings['seo_canonical'] || 'https://cafegoo.com',
      logo: socials['logo_url'] || '',
      description: settings['seo_description'] || '',
      ...(sameAs.length ? { sameAs } : {}),
    };
    return JSON.stringify(obj, null, 2);
  };

  const previewTitle = (settings['seo_title'] || '').trim() || 'Cafegoo — Kafe & Restoran Tətbiqi';
  const previewDesc  = (settings['seo_description'] || '').trim() || 'Cafegoo ilə ətrafındakı kafelər, kampaniyalar və rezervasiyaları kəşf et.';

  return (
    <div style={{ maxWidth: 680 }}>
      {/* Google Search Preview */}
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #E2E8F0', padding: 20, marginBottom: 24 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#1E293B', marginBottom: 14, display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ background: '#F1F5F9', borderRadius: 6, padding: '3px 8px', fontSize: 11, color: '#64748B', fontWeight: 600 }}>CANLI ÖNİZLƏMƏ</span>
          Google Axtarış Nəticəsi
        </div>
        <div style={{ border: '1px solid #E2E8F0', borderRadius: 12, padding: '16px 20px', background: '#FAFAFA', fontFamily: 'Arial, sans-serif' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
            <div style={{ width: 26, height: 26, borderRadius: '50%', background: '#fff', border: '1px solid #E2E8F0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, flexShrink: 0 }}>☕</div>
            <div>
              <div style={{ fontSize: 14, color: '#202124', fontWeight: 600, lineHeight: 1.2 }}>Cafegoo</div>
              <div style={{ fontSize: 12, color: '#4D5156' }}>https://cafegoo.com › ...</div>
            </div>
          </div>
          <div style={{ fontSize: 20, color: '#1a0dab', fontWeight: 400, marginBottom: 4, overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', lineHeight: 1.3 }}>
            {previewTitle.length > 60 ? previewTitle.slice(0, 60) + '...' : previewTitle}
          </div>
          <div style={{ fontSize: 14, color: '#4D5156', lineHeight: 1.58, overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
            {previewDesc.length > 160 ? previewDesc.slice(0, 160) + '...' : previewDesc}
          </div>
        </div>
        <div style={{ fontSize: 11, color: '#94A3B8', marginTop: 10 }}>Title və Meta Açıqlama sahələrini doldurduqca önizləmə avtomatik yenilənir.</div>
      </div>

      {/* GSC hint */}
      <div style={{ background: '#EFF6FF', border: '1px solid #BFDBFE', borderRadius: 12, padding: '14px 18px', marginBottom: 24, fontSize: 13, color: '#1D4ED8', lineHeight: 1.6 }}>
        <strong>💡 Google Search Console:</strong>{' '}
        <a href="https://search.google.com/search-console" target="_blank" rel="noreferrer" style={{ color: '#1D4ED8' }}>search.google.com/search-console</a>
        {' '}saytından cafegoo.com domenini əlavə et → "HTML tag" metodunu seç → meta content dəyərini buraya yapışdır.
      </div>

      {msg && (
        <div style={{ fontSize: 13, fontWeight: 600, padding: '10px 14px', borderRadius: 10, marginBottom: 18, background: msg.startsWith('✅') ? '#ECFDF5' : '#FEF2F2', color: msg.startsWith('✅') ? '#10B981' : '#E63950' }}>{msg}</div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        {SEO_FIELDS.map(f => (
          <div key={f.key} style={{ background: '#fff', borderRadius: 12, border: '1px solid #E2E8F0', padding: 18 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <label style={{ fontSize: 13, fontWeight: 700, color: '#1E293B' }}>{f.label}</label>
              {f.maxLen && charCount(f.key, f.maxLen)}
            </div>
            <p style={{ fontSize: 12, color: '#94A3B8', marginBottom: 8, lineHeight: 1.5 }}>{f.hint}</p>
            {f.type === 'textarea' ? (
              <textarea rows={3} value={settings[f.key] || ''} onChange={e => handleChange(f.key, e.target.value)}
                style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid #E2E8F0', fontSize: 13, resize: 'vertical', boxSizing: 'border-box' }} />
            ) : f.type === 'select' ? (
              <select value={settings[f.key] || f.options[0]} onChange={e => handleChange(f.key, e.target.value)}
                style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid #E2E8F0', fontSize: 13, background: '#fff', cursor: 'pointer' }}>
                {f.options.map(o => <option key={o} value={o}>{o}</option>)}
              </select>
            ) : (
              <input type="text" value={settings[f.key] || ''} onChange={e => handleChange(f.key, e.target.value)}
                style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid #E2E8F0', fontSize: 13, boxSizing: 'border-box' }} />
            )}
          </div>
        ))}
      </div>

      {/* JSON-LD Preview */}
      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #E2E8F0', padding: 18, marginTop: 20 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <label style={{ fontSize: 13, fontWeight: 700, color: '#1E293B' }}>JSON-LD Structured Data</label>
          <span style={{ fontSize: 11, background: '#ECFDF5', color: '#10B981', fontWeight: 700, padding: '3px 8px', borderRadius: 6 }}>Avtomatik</span>
        </div>
        <p style={{ fontSize: 12, color: '#94A3B8', marginBottom: 10, lineHeight: 1.5 }}>
          Sosial linklər, logo və açıqlama əsasında avtomatik yaradılır. Vebsaytın &lt;head&gt;-inə əlavə et.
        </p>
        <pre style={{ background: '#0F172A', color: '#7DD3FC', borderRadius: 10, padding: 16, fontSize: 12, overflowX: 'auto', lineHeight: 1.6, margin: 0 }}>
          {buildJsonLd()}
        </pre>
        <button
          onClick={() => { navigator.clipboard.writeText(`<script type="application/ld+json">\n${buildJsonLd()}\n</script>`); }}
          style={{ marginTop: 10, padding: '7px 14px', borderRadius: 8, background: '#F1F5F9', color: '#475569', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
        >
          📋 &lt;script&gt; tagı ilə kopyala
        </button>
      </div>

      <button onClick={saveAll} disabled={saving} style={{
        marginTop: 24, padding: '11px 28px', borderRadius: 10,
        background: saving ? '#F1F5F9' : '#E63950', color: saving ? '#94A3B8' : '#fff',
        fontSize: 14, fontWeight: 700, cursor: saving ? 'not-allowed' : 'pointer',
      }}>
        {saving ? 'Saxlanılır...' : '💾 Bütün SEO Ayarlarını Saxla'}
      </button>
    </div>
  );
}

// ── Social & Footer Manager ───────────────────────────────────────────────────
const SOCIAL_FIELDS = [
  { key: 'social_instagram', label: 'Instagram',  icon: '📸', placeholder: 'https://instagram.com/cafegooapp' },
  { key: 'social_facebook',  label: 'Facebook',   icon: '📘', placeholder: 'https://facebook.com/cafegooapp' },
  { key: 'social_x',         label: 'X (Twitter)', icon: '🐦', placeholder: 'https://x.com/cafegooapp' },
  { key: 'social_linkedin',  label: 'LinkedIn',   icon: '💼', placeholder: 'https://linkedin.com/company/cafegoo' },
  { key: 'social_youtube',   label: 'YouTube',    icon: '▶️', placeholder: 'https://youtube.com/@cafegoo' },
  { key: 'social_tiktok',    label: 'TikTok',     icon: '🎵', placeholder: 'https://tiktok.com/@cafegoo' },
];

function SocialManager() {
  const [settings, setSettings] = useState({});
  const [saving,   setSaving]   = useState(false);
  const [msg,      setMsg]      = useState('');

  useEffect(() => { load(); }, []);

  const load = async () => {
    const keys = [...SOCIAL_FIELDS.map(f => f.key), 'footer_tagline', 'footer_copyright'];
    const { data } = await supabase.from('site_settings').select('key, value').in('key', keys);
    if (data) {
      const map = {};
      data.forEach(r => { map[r.key] = r.value; });
      setSettings(map);
    }
  };

  const handleChange = (key, val) => setSettings(prev => ({ ...prev, [key]: val }));

  const saveAll = async () => {
    setSaving(true);
    const rows = Object.entries(settings).map(([key, value]) => ({ key, value: value || '' }));
    const { error } = await supabase.from('site_settings').upsert(rows, { onConflict: 'key' });
    setSaving(false);
    setMsg(error ? '❌ ' + error.message : '✅ Sosial ayarlar saxlandı');
    setTimeout(() => setMsg(''), 3000);
  };

  return (
    <div style={{ maxWidth: 680 }}>
      {msg && (
        <div style={{ fontSize: 13, fontWeight: 600, padding: '10px 14px', borderRadius: 10, marginBottom: 18,
          background: msg.startsWith('✅') ? '#ECFDF5' : '#FEF2F2',
          color: msg.startsWith('✅') ? '#10B981' : '#E63950' }}>{msg}</div>
      )}

      {/* Social Links */}
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #E2E8F0', padding: 20, marginBottom: 24 }}>
        <div style={{ fontWeight: 800, fontSize: 15, color: '#1E293B', marginBottom: 4 }}>Sosial Media Linklər</div>
        <div style={{ fontSize: 13, color: '#64748B', marginBottom: 18 }}>Vebsayt footer-ında göstəriləcək sosial media profilləri</div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {SOCIAL_FIELDS.map(f => (
            <div key={f.key}>
              <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 5 }}>
                {f.icon} {f.label}
              </label>
              <input
                type="url"
                value={settings[f.key] || ''}
                onChange={e => handleChange(f.key, e.target.value)}
                placeholder={f.placeholder}
                style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid #E2E8F0', fontSize: 13, boxSizing: 'border-box', color: '#1E293B' }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Footer Text */}
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #E2E8F0', padding: 20, marginBottom: 24 }}>
        <div style={{ fontWeight: 800, fontSize: 15, color: '#1E293B', marginBottom: 4 }}>Footer Mətni</div>
        <div style={{ fontSize: 13, color: '#64748B', marginBottom: 18 }}>Saytın aşağı hissəsindəki mətn</div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 5 }}>Qısa Təsvir (tagline)</label>
            <input
              type="text"
              value={settings['footer_tagline'] || ''}
              onChange={e => handleChange('footer_tagline', e.target.value)}
              placeholder="Kafelər, kampaniyalar, rezervasiyalar — hamısı bir yerdə."
              style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid #E2E8F0', fontSize: 13, boxSizing: 'border-box' }}
            />
          </div>
          <div>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 5 }}>Copyright</label>
            <input
              type="text"
              value={settings['footer_copyright'] || ''}
              onChange={e => handleChange('footer_copyright', e.target.value)}
              placeholder="© 2025 Cafegoo. Bütün hüquqlar qorunur."
              style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid #E2E8F0', fontSize: 13, boxSizing: 'border-box' }}
            />
          </div>
        </div>
      </div>

      {/* Footer preview */}
      <div style={{ background: '#1E293B', borderRadius: 14, padding: '20px 24px', marginBottom: 24 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#64748B', letterSpacing: 1, marginBottom: 12 }}>FOOTER ÖNİZLƏMƏSİ</div>
        <div style={{ display: 'flex', gap: 12, marginBottom: 10, flexWrap: 'wrap' }}>
          {SOCIAL_FIELDS.filter(f => settings[f.key]).map(f => (
            <a key={f.key} href={settings[f.key]} target="_blank" rel="noreferrer"
              style={{ fontSize: 18, opacity: 0.8, textDecoration: 'none' }}>{f.icon}</a>
          ))}
          {!SOCIAL_FIELDS.some(f => settings[f.key]) && (
            <span style={{ fontSize: 12, color: '#475569' }}>Sosial link əlavə etdikdə burada görünəcək</span>
          )}
        </div>
        {settings['footer_tagline'] && (
          <div style={{ fontSize: 13, color: '#94A3B8', marginBottom: 6 }}>{settings['footer_tagline']}</div>
        )}
        <div style={{ fontSize: 12, color: '#475569' }}>
          {settings['footer_copyright'] || '© 2025 Cafegoo. Bütün hüquqlar qorunur.'}
        </div>
      </div>

      <button onClick={saveAll} disabled={saving} style={{
        padding: '11px 28px', borderRadius: 10,
        background: saving ? '#F1F5F9' : '#E63950', color: saving ? '#94A3B8' : '#fff',
        fontSize: 14, fontWeight: 700, cursor: saving ? 'not-allowed' : 'pointer',
      }}>
        {saving ? 'Saxlanılır...' : '💾 Sosial Ayarları Saxla'}
      </button>
    </div>
  );
}

// ── Announcement Manager ──────────────────────────────────────────────────────
const BANNER_COLORS = [
  { label: 'Mavi (Məlumat)',  value: '#1D4ED8', bg: '#EFF6FF', text: '#1D4ED8' },
  { label: 'Yaşıl (Uğur)',   value: '#059669', bg: '#ECFDF5', text: '#059669' },
  { label: 'Sarı (Xəbərdarlıq)', value: '#D97706', bg: '#FFFBEB', text: '#D97706' },
  { label: 'Qırmızı (Vacib)', value: '#E63950', bg: '#FFF1F3', text: '#E63950' },
];

function AnnouncementManager() {
  const [settings, setSettings] = useState({
    announcement_enabled: 'false',
    announcement_text: '',
    announcement_color: '#1D4ED8',
    announcement_link: '',
    announcement_link_label: '',
  });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg]       = useState('');

  useEffect(() => { load(); }, []);

  const load = async () => {
    const keys = Object.keys(settings);
    const { data } = await supabase.from('site_settings').select('key, value').in('key', keys);
    if (data) {
      const map = {};
      data.forEach(r => { map[r.key] = r.value; });
      setSettings(prev => ({ ...prev, ...map }));
    }
  };

  const handleChange = (key, val) => setSettings(prev => ({ ...prev, [key]: val }));

  const saveAll = async () => {
    setSaving(true);
    const rows = Object.entries(settings).map(([key, value]) => ({ key, value: value || '' }));
    const { error } = await supabase.from('site_settings').upsert(rows, { onConflict: 'key' });
    setSaving(false);
    setMsg(error ? '❌ ' + error.message : '✅ Elan ayarları saxlandı');
    setTimeout(() => setMsg(''), 3000);
  };

  const isEnabled = settings['announcement_enabled'] === 'true';
  const currentColor = BANNER_COLORS.find(c => c.value === settings['announcement_color']) || BANNER_COLORS[0];

  return (
    <div style={{ maxWidth: 680 }}>
      {msg && (
        <div style={{ fontSize: 13, fontWeight: 600, padding: '10px 14px', borderRadius: 10, marginBottom: 18,
          background: msg.startsWith('✅') ? '#ECFDF5' : '#FEF2F2',
          color: msg.startsWith('✅') ? '#10B981' : '#E63950' }}>{msg}</div>
      )}

      {/* Banner Preview */}
      {isEnabled && settings['announcement_text'] && (
        <div style={{
          background: currentColor.bg, border: `1px solid ${currentColor.value}30`,
          borderRadius: 12, padding: '12px 18px', marginBottom: 24,
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
        }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: '#64748B', letterSpacing: 1, flexShrink: 0 }}>ÖNİZLƏMƏ</div>
          <div style={{ flex: 1, fontSize: 14, color: currentColor.text, fontWeight: 600 }}>
            {settings['announcement_text']}
            {settings['announcement_link'] && settings['announcement_link_label'] && (
              <a href={settings['announcement_link']} target="_blank" rel="noreferrer"
                style={{ marginLeft: 10, color: currentColor.text, fontWeight: 700, textDecoration: 'underline', fontSize: 13 }}>
                {settings['announcement_link_label']} →
              </a>
            )}
          </div>
        </div>
      )}

      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #E2E8F0', padding: 24 }}>
        {/* Toggle */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, paddingBottom: 20, borderBottom: '1px solid #F1F5F9' }}>
          <div>
            <div style={{ fontWeight: 800, fontSize: 15, color: '#1E293B' }}>Elan Banneri</div>
            <div style={{ fontSize: 13, color: '#64748B', marginTop: 3 }}>Saytın yuxarısında göstərilən xəbər xətti</div>
          </div>
          <button
            onClick={() => handleChange('announcement_enabled', isEnabled ? 'false' : 'true')}
            style={{
              width: 52, height: 28, borderRadius: 14, border: 'none', cursor: 'pointer', position: 'relative',
              background: isEnabled ? '#E63950' : '#E2E8F0', transition: 'background 0.2s',
            }}
          >
            <div style={{
              width: 22, height: 22, borderRadius: '50%', background: '#fff',
              position: 'absolute', top: 3, transition: 'left 0.2s',
              left: isEnabled ? 27 : 3, boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
            }} />
          </button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
          {/* Text */}
          <div>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 5 }}>Elan Mətni</label>
            <input
              type="text"
              value={settings['announcement_text'] || ''}
              onChange={e => handleChange('announcement_text', e.target.value)}
              placeholder="Tətbiq yeniləndi — App Store-dan yüklə!"
              style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid #E2E8F0', fontSize: 13, boxSizing: 'border-box' }}
            />
          </div>

          {/* Color picker */}
          <div>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 8 }}>Rəng</label>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              {BANNER_COLORS.map(c => (
                <button
                  key={c.value}
                  onClick={() => handleChange('announcement_color', c.value)}
                  style={{
                    padding: '7px 14px', borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer',
                    background: c.bg, color: c.text,
                    border: `2px solid ${settings['announcement_color'] === c.value ? c.value : 'transparent'}`,
                  }}
                >
                  {c.label}
                </button>
              ))}
            </div>
          </div>

          {/* Link */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div>
              <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 5 }}>Link URL (isteğe bağlı)</label>
              <input
                type="url"
                value={settings['announcement_link'] || ''}
                onChange={e => handleChange('announcement_link', e.target.value)}
                placeholder="https://cafegoo.com/yenilikler"
                style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid #E2E8F0', fontSize: 13, boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 5 }}>Link Mətni</label>
              <input
                type="text"
                value={settings['announcement_link_label'] || ''}
                onChange={e => handleChange('announcement_link_label', e.target.value)}
                placeholder="Ətraflı bax"
                style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid #E2E8F0', fontSize: 13, boxSizing: 'border-box' }}
              />
            </div>
          </div>
        </div>
      </div>

      <button onClick={saveAll} disabled={saving} style={{
        marginTop: 24, padding: '11px 28px', borderRadius: 10,
        background: saving ? '#F1F5F9' : '#E63950', color: saving ? '#94A3B8' : '#fff',
        fontSize: 14, fontWeight: 700, cursor: saving ? 'not-allowed' : 'pointer',
      }}>
        {saving ? 'Saxlanılır...' : '💾 Elan Ayarlarını Saxla'}
      </button>
    </div>
  );
}

// ── Main ──────────────────────────────────────────────────────────────────────
export default function WebsitePage() {
  const [tab, setTab] = useState(0);

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 24, fontWeight: 900, color: '#1E293B', marginBottom: 4 }}>Vebsayt İdarəetməsi</h1>
        <p style={{ fontSize: 14, color: '#64748B' }}>cafegoo.com kontenti, mesajlar və FAQ-ları idarə et</p>
      </div>

      <SiteLogo />

      <div style={{ display: 'flex', gap: 4, background: '#F1F5F9', borderRadius: 10, padding: 4, marginBottom: 24, width: 'fit-content' }}>
        {TABS.map((t, i) => (
          <button key={t} onClick={() => setTab(i)} style={{
            padding: '8px 18px', borderRadius: 8, fontSize: 13, fontWeight: 600,
            background: tab === i ? '#fff' : 'transparent',
            color: tab === i ? '#E63950' : '#64748B',
            boxShadow: tab === i ? '0 1px 4px rgba(0,0,0,0.08)' : 'none',
            transition: 'all 0.2s',
          }}>
            {t}
          </button>
        ))}
      </div>

      {tab === 0 && <ContactMessages />}
      {tab === 1 && <FAQManager />}
      {tab === 2 && <SEOManager />}
      {tab === 3 && <SocialManager />}
      {tab === 4 && <AnnouncementManager />}
    </div>
  );
}
